import {
  AudienceSessionWidgetSchema,
  type AudienceSessionWidget,
} from '@inference.engine/widgets/web';
import { inferenceHttp } from '@/lib/api/http-client';
import { logger } from '@/lib/utils/logger';

/**
 * Reads the audience-session transcript live by contextId via
 * `GET /audience-sessions/:contextId/snapshot`, for the headless PDF print
 * page. Unlike `getSavedAudienceSessionSnapshot` (which reads a persisted
 * Save-to-project artifact), this builds the snapshot on demand from the
 * session, so nothing is persisted for the export.
 */
export const getAudienceSessionSnapshotForRender = async (
  workspaceId: string,
  contextId: string,
): Promise<AudienceSessionWidget | null> => {
  const base = inferenceHttp.getConfig().baseURL ?? '';
  const response = await inferenceHttp.instance.get(
    `${base}/api/v1/audience-sessions/${contextId}/snapshot`,
    { params: { workspaceId }, withCredentials: true },
  );

  // A null/malformed body returns null (not a throw) so the print page renders
  // its graceful fallback rather than an error state.
  const parsed = AudienceSessionWidgetSchema.safeParse(response.data);
  if (!parsed.success) {
    logger.warn(
      'getAudienceSessionSnapshotForRender: snapshot failed schema validation',
      parsed.error,
    );
    return null;
  }

  return parsed.data;
};
